<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar color="navbar">
        <ion-title>FormSheets</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content padding></ion-content>
  </div>
</template>

<script>
import Helpers from "../mixins/Helpers";
import Plugins from "../mixins/Plugins";
export default {
  name: "user-logout",
  mixins: [Helpers, Plugins],
  data() {
    return {};
  },
  computed: {},
  created() {},
  async mounted() {
    try {
      await this.$store.dispatch("userLogout");
      this.showRootPage("login");
    } catch (error) {
      console.error("UserLogout", error);
    }
  },
  methods: {}
};
</script>

<style scoped>
</style>